/* The House of Cobalt, quiz logic.
 *
 * Matches the HTML structure in snippets/page-quiz-body.liquid:
 *   - <section id="intro"> with onclick="startQuiz()" on the Begin button
 *   - <section id="quiz"> containing .step[data-step="1..6"] and the result
 *     card at data-step="7"
 *   - Each .answer carries data-q (question id) and data-v (value)
 *   - "Continue/See my routine" buttons use onclick="next()" / "finish()"
 *   - "Back" buttons use onclick="back()"
 *
 * Multi-select: any .step element with class .multi (currently only Q2 - the
 * wellness framework question) allows multiple selections. Single-select is the
 * default and behaves like radio buttons.
 *
 * On finish, the script encodes selected answers as URL params and navigates
 * to /pages/results so results.js can populate the routine recommendation.
 */
(function () {
  var intro = document.getElementById('intro');
  var quiz  = document.getElementById('quiz');
  if (!intro || !quiz) return;

  var progress = quiz.querySelector('.quiz-progress');
  var answers  = {};        // single-select: { q: 'v' };  multi-select: { q: ['v1','v2'] }
  var current  = 1;
  var TOTAL    = 9;

  function showStep(n) {
    quiz.querySelectorAll('.step').forEach(function (s) {
      s.classList.toggle('active', s.getAttribute('data-step') === String(n));
    });
    if (progress) {
      progress.querySelectorAll('span').forEach(function (d, i) {
        d.classList.toggle('active', i < n);
      });
    }
    current = n;
    window.scrollTo({ top: 0, behavior: 'smooth' });
    // On the personal finish step, drop the cursor into the name field.
    if (n === TOTAL) {
      var nameInput = document.getElementById('quiz-name');
      if (nameInput) setTimeout(function () { nameInput.focus(); }, 350);
    }
  }

  function syncContinueButton(stepEl) {
    var nextBtn = stepEl.querySelector('.btn-next');
    if (!nextBtn) return;
    var isMulti = stepEl.classList.contains('multi');
    var anySelected = !!stepEl.querySelector('.answer.selected');
    nextBtn.disabled = !anySelected;
    if (isMulti) {
      var count = stepEl.querySelectorAll('.answer.selected').length;
      nextBtn.textContent = count > 0
        ? 'Continue (' + count + ' selected) →'
        : 'Continue →';
    }
  }

  // Answer selection, delegated to support multi-select
  quiz.addEventListener('click', function (e) {
    var ans = e.target.closest('.answer');
    if (!ans) return;
    var stepEl = ans.closest('.step');
    if (!stepEl) return;
    var q = ans.getAttribute('data-q');
    var v = ans.getAttribute('data-v');
    var isMulti = stepEl.classList.contains('multi');

    if (isMulti) {
      // Toggle on / off; collect array.
      ans.classList.toggle('selected');
      var selected = [];
      stepEl.querySelectorAll('.answer.selected').forEach(function (a) {
        selected.push(a.getAttribute('data-v'));
      });
      answers[q] = selected;
    } else {
      stepEl.querySelectorAll('.answer').forEach(function (a) { a.classList.remove('selected'); });
      ans.classList.add('selected');
      answers[q] = v;
    }
    syncContinueButton(stepEl);
  });

  // Expose nav functions globally, the HTML calls these via onclick.
  window.startQuiz = function () {
    intro.style.display = 'none';
    quiz.style.display = '';
    showStep(1);
  };

  window.next = function () {
    if (current < TOTAL) showStep(current + 1);
  };

  window.back = function () {
    if (current > 1) showStep(current - 1);
  };

  window.finish = function () {
    // Encode answers as URL params. Multi-select values get joined with commas.
    var params = [];
    Object.keys(answers).forEach(function (k) {
      var val = answers[k];
      if (Array.isArray(val)) val = val.join(',');
      params.push(encodeURIComponent(k) + '=' + encodeURIComponent(val));
    });
    // Personal touch, carry the name through to the results page.
    var nameInput = document.getElementById('quiz-name');
    var name = nameInput ? nameInput.value.trim() : '';
    if (name) params.push('name=' + encodeURIComponent(name));
    window.location.href = '/pages/results?' + params.join('&');
  };
})();
